export const CHAT_CONSTANTS = {
    DEFAULT_AVATAR: 'https://acupoint-resource.oss-cn-shenzhen.aliyuncs.com/download/default_user_avatar.png',
    PAGE_SIZE: 10,
    SCROLL_THRESHOLD: 50,
    SCROLL_DELAY: 500,
    MESSAGE_GROUP_TIME_GAP: 5 * 60 * 1000, // 5分钟
    RETRY_COUNT: 3,
    RETRY_DELAY: 1000,
    INITIAL_MESSAGE: '你好',
    LOADING_TEXT: 'AI正在回复中...',
    INPUT_PLACEHOLDER: '输入消息...',
    WAIT_TEXT: '请等待...',
    SEND_TEXT: '发送',
    SUGGESTED_QUESTIONS_TITLE: '您可能想问',
} as const;

export const UI_CONSTANTS = {
    ANIMATION_DURATION: 300,
    LOADING_DOTS_DELAY: 200,
} as const;

// localStorage keys
export const INPUT_MODE_STORAGE_KEY = 'chat_input_mode';

// 默认输入模式配置
export const INPUT_MODE_DEFAULTS = {
    DEFAULT_MODE: false, // false 表示文字输入模式，true 表示语音输入模式
} as const; 